import { AgResourceLanguage } from '../types';
import { orderList as EnUsOrderList } from '../en-us/orderList';

export const orderList: AgResourceLanguage['orderList'] = {
  ...EnUsOrderList,
  filterOrders: {
    filterTitle: 'Visa beställningar för:',
    filterOptionTitle: 'Alla Abonnemang'
  },
  emptyPastOrders: {
    title: `Du har inga beställningar än`,
    description: 'Börja handla och kolla den här sidan senare.',
    buttonName: 'Hämta Din AG1'
  },
  emptyUpcomingOrders: {
    title: 'Du har inga kommande beställningar',
    buttonName: 'Hämta Din AG1'
  },
  upcomingOrders: {
    title: 'Kommande Beställningar',
    card: {
      orderDateLabel: 'Beställningsdatum',
      subscriptionNameLabel: 'Abonnemang',
      subscriptionStatusLabel: 'Status',
      unpaidStatus: 'Obetald',
      totalAmountLabel: 'Totalt',
      shipButton: 'Skicka Nu',
      editDetailsButton: 'Redigera Detaljer',
      skipShipmentButton: 'Hoppa över Leverans'
    }
  },
  pastOrders: {
    title: 'Beställningar',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Beställningsnummer',
      dateColumn: 'Datum',
      subscriptionNameColumn: 'Abonnemang',
      statusColumn: 'Status',
      totalColumn: 'Totalt',
      trackButton: 'Spåra Beställning',
      oneTimeLabel: 'Engångsköp'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Beställning',
      dateLabel: 'Datum:',
      subscriptionLabel: 'Abonnemang',
      statusLabel: 'Status',
      totalLabel: 'Totalt',
      trackButtonMobile: 'Spåra Beställning',
      trackButtonTablet: 'Spåra Beställning',
      viewDetailsButton: 'Visa Detaljer'
    }
  }
};
